module.exports = __webpack_public_path__ + "img/744.017785d7.jpg";